const config = {
  env: process.env.VUE_APP_ENV,
};
config.envUrlMixin = config.env === 'pro' ? '' : `${config.env}/`;

config.envUrlMixin = config.env !== 'pro' ? `${config.env}/` : '';

window.env = {
  VUE_APP_ENV: config.env,
  valueOf() {
    return config.env;
  },
  toString() {
    return config.env;
  },
};

if (process.env.VUE_APP_ENV === 'dev') {
  Object.assign(config, {
    API: 'https://fat-api.hellobike.com/api',
    EBIKE_API: 'https://fat-ebike.hellobike.com/api',
    BIKE_API: 'https://fat-bike.hellobike.com/api',
    MARKET_API: 'https://fat-marketingapi.hellobike.com/api',
  });
} else if (process.env.VUE_APP_ENV === 'fat') {
  Object.assign(config, {
    API: 'https://fat-api.hellobike.com/api',
    EBIKE_API: 'https://fat-ebike.hellobike.com/api',
    BIKE_API: 'https://fat-bike.hellobike.com/api',
    MARKET_API: 'https://fat-marketingapi.hellobike.com/api',
  });
} else if (process.env.VUE_APP_ENV === 'uat') {
  Object.assign(config, {
    API: 'https://uat-api.hellobike.com/api',
    EBIKE_API: 'https://uat-ebike.hellobike.com/api',
    BIKE_API: 'https://uat-bike.hellobike.com/api',
    MARKET_API: 'https://uat-marketingapi.hellobike.com/api',
  });
} else if (process.env.VUE_APP_ENV === 'pro') {
  Object.assign(config, {
    API: 'https://api.hellobike.com/api',
    EBIKE_API: 'https://ebike.hellobike.com/api',
    BIKE_API: 'https://bike.hellobike.com/api',
    MARKET_API: 'https://marketingapi.hellobike.com/api',
  });
} else if (process.env.VUE_APP_ENV === 'pre') {
  Object.assign(config, {
    API: 'https://pre-api.hellobike.com/api',
    EBIKE_API: 'https://pre-ebike.hellobike.com/api',
    BIKE_API: 'https://pre-bike.hellobike.com/api',
    MARKET_API: 'https://pre-marketingapi.hellobike.com/api',
  });
}

export default config;
